import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MetricsService } from '@jeppesen-foreflight/jmkw-analytics';
import { AVIATION_CONFIG_TOKEN } from './aviation.config';
import { AviationPluginService } from './aviation.plugin.service';
import { AirspaceDetailComponent } from './plugins/navigation/selected-item/widgets/airspace-detail/airspace-detail.component';
import { AirwayDetailComponent } from './plugins/navigation/selected-item/widgets/airway-detail/airway-detail.component';
import { AmdbDetailComponent } from './plugins/navigation/selected-item/widgets/amdb-detail/amdb-detail.component';
import { NavaidDetailComponent } from './plugins/navigation/selected-item/widgets/navaid-detail/navaid-detail.component';
import { RunwayDetailComponent } from './plugins/navigation/selected-item/widgets/runway-detail/runway-detail.component';
import { NavigationPopoutComponent } from './plugins/navigation/buttons/navigation-button/navigation-button-popout/navigation-popout.component';
import { JmkwAviationConfig } from '../types/jeppesen.environment';

@NgModule({
  imports: [
    NavigationPopoutComponent,
    RunwayDetailComponent,
    AirwayDetailComponent,
    AmdbDetailComponent,
    NavaidDetailComponent,
    AirspaceDetailComponent,
    CommonModule
  ],
  providers: [AviationPluginService, MetricsService]
})
export class AviationPluginModule {
  static forRoot(
    aviationConfig: Partial<JmkwAviationConfig>
  ): ModuleWithProviders<AviationPluginModule> {
    return {
      ngModule: AviationPluginModule,
      providers: [
        {
          provide: AVIATION_CONFIG_TOKEN,
          useValue: aviationConfig
        }
      ]
    };
  }
}
